module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#podcast",
      toString: function () {
        return this.url;
      }
    }